import React, { useEffect, useState } from "react";
import ForgottenPasswordWindow from "../features/login/components/ForgottenPasswordWindow";
import LoginWindow from "../features/login/components/LoginWindow";
import ChangePasswordWindow from "../features/login/components/ChangePassword";
import { wakeUpDatabase } from "../api/UserAPIUtils";

interface LoginPageProps {
  redirectRoute: string;
}

const LoginPage: React.FC<LoginPageProps> = ({ redirectRoute }) => {
  const [window, setWindow] = useState<
    "login" | "forgottenPassword" | "changePassword"
  >("login");

  useEffect(() => {
    const wakeUp = async () => {
      try {
        const message = await wakeUpDatabase();
      } catch (error) {
        console.error("Failed to wake up database", error);
      }
    };

    wakeUp();
  }, []);

  const renderWindow = () => {
    switch (window) {
      case "login":
        return <LoginWindow setWindow={setWindow} redirectRoute="" />;
      case "forgottenPassword":
        return <ForgottenPasswordWindow setWindow={setWindow} />;
      case "changePassword":
        return <ChangePasswordWindow />;
      default:
        return null;
    }
  };

  return (
    <>
      {/* Mobile Blocker
      <div className="block lg:hidden h-screen w-full flex items-center justify-center p-4 text-center bg-white">
        <div>
          <h1 className="text-2xl font-semibold text-gray-800 mb-2">
            Unsupported Screen Size
          </h1>
          <p className="text-gray-600">
            Please use a desktop device to access the login page.
          </p>
        </div>
      </div> */}

      {/* Login UI for Desktop */}
      <div className="">{renderWindow()}</div>
    </>
  );
};

export default LoginPage;
